import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import axios from "axios";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import Notification from "../../../elements/notification/Notification";
import LogsList from "./LogsList";
import LogsFilter from "../../../elements/logs/LogsFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import { parseAxiosError } from "../../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../../utils/consts";

import { StyledLogsWrapper } from "../../styledLogs";

const LogsContainer = ({ t }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState({
    main: false,
    fragment: false
  });

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, false, true),
    "currentTab": checkFilterItem(history, "currentTab", "system"),
    "datetime[gte]": checkFilterItem(history, "datetime[gte]", null, true),
    "datetime[lte]": checkFilterItem(history, "datetime[lte]", null, true),
    "level_name": checkFilterItem(history, "level_name", null),
    "user": checkFilterItem(history, "user", null),
    "role": checkFilterItem(history, "role", null),
    "action": checkFilterItem(history, "action", null),
    "message": checkFilterItem(history, "message", null),
    "ip": checkFilterItem(history, "ip", null)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchLogs = () => {
    let itemsPerPage;

    if (logs.length === 0) {
      setLoading({ main: true, fragment: false });
      itemsPerPage = 100;
    } else {
      setLoading({ main: false, fragment: true });
      itemsPerPage = 30;
    }

    let filterUrl = fetchFilterData(filterData);

    history.replace(filterUrl);

    axios.get("/api/app-logs/list" + filterUrl + "&itemsPerPage=" + itemsPerPage, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        let requestLogs = response.data.list;

        if (response.data.page === 1) {
          setLogs(requestLogs);
          return;
        }

        setLogs([...logs, ...requestLogs]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => setLoading({ main: false, fragment: false }));
  };

  useEffect(() => {
    fetchLogs();

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [filterData]);

  useEffect(() => {
    setFilterData(prev => {
      if (prev.page !== 1) {
        return { ...prev, page: 1 };
      }

      return prev;
    });
  }, []);

  const onScroll = () => {
    const scrollTop = document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;

    if (Math.ceil(scrollTop + clientHeight) >= scrollHeight) {
      setFilterData({ ...filterData, page: filterData.page + 1 });
    }
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledLogsWrapper>
        <Helmet>
          <title>{t("meta.title")}</title>
        </Helmet>
        <div className="logs-head">
          <LogsFilter
            filterData={filterData}
            setFilterData={setFilterData}
          />
        </div>
        <FilterAppliedList
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <LogsList
          loading={loading}
          logs={logs}
        />
      </StyledLogsWrapper>
    </>
  );
};

export default LogsContainer;